import React from 'react';
import {VolumeUp, VolumeOff, Undo, Clear} from 'material-ui-icons';
import {MenuItem, Menu} from 'material-ui';

function TopLifeWorkoutMenu({
	anchorEl,
	handleCloseMenu,
	open,
	onCloseWorkoutPress,
	onUndoPress,
	onSoundControlPress,
	isUndoDisabled,
	t,
	wantsSound,
}) {
	const SoundIcon = wantsSound ? VolumeUp : VolumeOff;
	return (
		<Menu
			id='menu-appbar'
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={open}
			onClose={handleCloseMenu}
		>
			<MenuItem onClick={onCloseWorkoutPress}>
				<Clear style={{marginRight: 15}} />
				{t('workout:closeTraining')}
			</MenuItem>

			<MenuItem disabled={isUndoDisabled} onClick={onUndoPress}>
				<Undo style={{marginRight: 15}} />
				{t('workout:goBack')}
			</MenuItem>

			<MenuItem onClick={onSoundControlPress}>
				<SoundIcon style={{marginRight: 15}} />
				{t(`workout:${wantsSound ? 'toneOff' : 'toneOn'}`)}
			</MenuItem>
		</Menu>
	);
}

export default TopLifeWorkoutMenu;



// WEBPACK FOOTER //
// ./src/workout/TopLifeWorkoutMenu.js